import React from 'react';

/** Node motif borrowed from the brand mark, used between light sections. */
export default function Divider() {
  return (
    <div className="divider" aria-hidden="true">
      <span className="divider__line" />
      <span className="divider__dot" />
      <span className="divider__line divider__line--right" />
    </div>
  );
}
